/**
 * Los stores donde la sesión tiene `categorias` concedido, ordenados. La forma es
 * `permissions.store.categorias[code]`; `by_relation` no cuenta, porque Categorías no tiene
 * participación.
 *
 * Lo usan el form, para ofrecer un árbol por store, y la ficha, para mostrar sólo las
 * categorías de los árboles que quien mira puede ver. Sale de la sesión, que se congela al
 * login: recién concedido, hay que re-loguear.
 */
export const storesConCategorias = (identity: any): string[] => {
  const bucket = identity?.permissions?.store?.categorias ?? {};
  return Object.entries(bucket)
    .filter(([, valor]) => {
      const v = String(valor ?? "").trim().toLowerCase();
      return v !== "" && v !== "no_access" && v !== "by_relation";
    })
    .map(([code]) => code)
    .sort();
};

/**
 * Los árboles que quien mira puede ver: los que usa alguno de sus stores con Categorías.
 * Un árbol se ve entero o no se ve: las tiendas que lo comparten muestran lo mismo.
 */
export const arbolesVisibles = <T extends { stores: string[] }>(
  roots: T[],
  stores: string[],
): T[] => {
  const mios = new Set(stores);
  return roots.filter((r) => r.stores.some((s) => mios.has(s)));
};
